import { ActionDescription, ActionKind } from "../description";
import { ActionDescriptor } from "./action-descriptor";
import { SerializedComponent } from "../../components/SerializedApp";
import { ComponentBuilder } from "../components";
import { BaseActionHandler } from "./base";

interface ReshuffleActionDescription extends ActionDescription {}

export class ReshuffleHandler extends BaseActionHandler<ReshuffleActionDescription> {
    public readonly kind = ActionKind.Reshuffle;

    public readonly iconName = "01-button-shuffle";

    public getDescriptor(): ActionDescriptor {
        return {
            name: "Shuffle Order",
            needsScreenContext: false,
            properties: [],
        };
    }

    public makeAction(builder: ComponentBuilder): SerializedComponent | undefined {
        const { b } = builder;

        // the following would be different TODO: fix
        return b.action("Reshuffle", {});
    }
}
